import { gql } from '../../__generated__/gql'

export const COMMUNITY_DELETE_POST_MUTATION = gql(`
    mutation deleteCommunityPost( $postId: Int! ) {
      deleteCommunityPost(input: { postId: $postId }) {
        clientMutationId
      }
    }
`)
